import { useContext, useEffect, useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import consts from '../Utilities/appConsts.json';
import { LanguageContext } from '../language/LanguageContext';

function ModalAlert({ open, onClose, title, content,textFalse,textTrue }) {
  const closeButtonRef = useRef(null);
  const { getTranslation } = useContext(LanguageContext);
  const closeLabel = getTranslation(consts.CLOSE_POPUP);

  useEffect(() => {
    if (open) {
      closeButtonRef.current?.focus();
    }
  }, [open]);

  const handleDialogClose = (_, reason) => {
    if (reason === 'escapeKeyDown' || reason === 'backdropClick') {
      onClose(false);
    }
  };

  return (
    <Dialog
      className="dialog"
      open={open}
      fullScreen={false}
      onClose={handleDialogClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" className="font_lg color_gray">
        <IconButton
          ref={closeButtonRef}
          autoFocus
          onClick={() => onClose(false)}
          aria-label={closeLabel}
          className="dialog-close-button"
        >
          <CloseIcon />
        </IconButton>
        <span>{title}</span>
      </DialogTitle>
      <DialogContentText id="alert-dialog-description" className="font_md">
        {content}
      </DialogContentText>
      <DialogActions>
      {textFalse && <Button onClick={() => onClose(false)}>{textFalse}</Button>}
      {textTrue && <Button onClick={() => onClose(true)}>{textTrue}</Button>}
      </DialogActions>
    </Dialog>
  );
}

export default ModalAlert;
